import VirtualDataList from 'commons/components/VirtualDataList';
import { TransferListRow, TransferMobileSkeleton } from './components';
import { useTransfersMobile } from '../../hooks';
import { TransferListPage } from '../components';

function TransferListMobilePage() {
  const {
    ids,
    data,
    showSkeleton,
    showSpinner,
    isDataEmpty,
    isError,
    refetch,
    handleInfiniteScroll,
    handlePullToRefresh,
    pagination,
  } = useTransfersMobile();

  const offset =
    pagination.totalResults - pagination.perPage * (pagination.currentPage - 1);

  return (
    <TransferListPage
      skeleton={<TransferMobileSkeleton />}
      isLoading={showSkeleton}
      isEmpty={isDataEmpty}
      isError={isError}
      onRetry={refetch}
    >
      <VirtualDataList
        onRefresh={handlePullToRefresh}
        isPullable
        data={ids}
        endReached={handleInfiniteScroll}
        itemContent={(index) => (
          <TransferListRow
            key={index}
            transfer={data[index]}
            number={offset - index}
          />
        )}
        showFooter={showSpinner}
      />
    </TransferListPage>
  );
}

export default TransferListMobilePage;
